module.exports = __webpack_public_path__ + "static/media/drs2.png.8731cdd7.jpg";